
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.104 29.104","height":"110","width":"110"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.301 15.948c0-.399.133-.798.133-1.33 0-.531 0-.93-.133-1.329l2.793-2.26c.265-.266.265-.532.133-.798l-2.66-4.653c-.133-.133-.398-.266-.797-.133l-3.324 1.33c-.665-.533-1.463-.932-2.26-1.33l-.532-3.457c.133-.4-.266-.665-.532-.665h-5.313c-.266 0-.665.266-.665.532l-.532 3.59c-.797.265-1.462.797-2.26 1.33l-3.19-1.33c-.4-.133-.666 0-.932.265l-2.659 4.654c-.133.133 0 .532.266.798l2.792 2.127c0 .399-.133.798-.133 1.33 0 .531 0 .93.133 1.33l-2.792 2.26c-.266.265-.266.531-.133.797l2.66 4.654c.132.133.398.266.797.133l3.324-1.33c.665.532 1.463.93 2.26 1.33l.532 3.456c0 .266.266.532.665.532h5.318c.266 0 .665-.266.665-.532l.532-3.456c.797-.4 1.595-.798 2.26-1.33l3.324 1.33c.266.133.665 0 .798-.266l2.659-4.654c.133-.266.133-.665-.133-.798zm-9.836 3.324c-2.526 0-4.653-2.127-4.653-4.653 0-2.527 2.127-4.654 4.653-4.654 2.527 0 4.654 2.127 4.654 4.654 0 2.526-2.127 4.653-4.654 4.653z","fill":"#f5f5f5"}})])
          )
        }
      }
    